export default class Accordion {
  constructor(accordion) {
    this.accordionItems = accordion.querySelectorAll('.--js-single-accordion-item');
    this.accordionButtons = accordion.querySelectorAll('.--js-accordion-title-button');

    this.setEvents()
  }

  setEvents() {
    if (this.accordionButtons.length) {
      this.accordionButtons.forEach(button => button.addEventListener('click', () => {
        this.toggleAccordion(button.parentElement, button)
      }));
    }
  }

  toggleAccordion(clickedAccordionItem, button) {
    const buttonExpanded = button.getAttribute('aria-expanded');
    const itemContent = clickedAccordionItem.querySelector('.--js-accordion-content');

    //console.log(button, clickedAccordionItem);
    // Close others
    this.closeAllAccordionsExceptedClickedItem(clickedAccordionItem);

    // if button aria-expanded is set to true (is open)
    if (buttonExpanded === 'true') {
      // Close item
      button.setAttribute('aria-expanded', 'false');
      itemContent.setAttribute('aria-hidden', 'true');
      this.slideUp(itemContent);
    } else {
      // Open Item
      button.setAttribute('aria-expanded', 'true');
      itemContent.setAttribute('aria-hidden', 'false');
      this.slideDown(itemContent, 250, clickedAccordionItem);
    }

  }

  closeAllAccordionsExceptedClickedItem(currentItem) {

    if (this.accordionItems.length) {

      this.accordionItems.forEach(item => {

        const itemButton = item.querySelector('.--js-accordion-title-button');
        const itemContent = item.querySelector('.--js-accordion-content');

        if (item.dataset.item !== currentItem.dataset.item) {
          itemButton.setAttribute('aria-expanded', 'false');
          itemContent.setAttribute('aria-hidden', 'true');
          this.slideUp(itemContent);
        }

      })
    }
  }

  slideUp(target, duration = 250) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }

  slideDown(target, duration = 250, currentItem) {

    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;

    const height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');

    window.setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');

      currentItem.scrollIntoView({ behavior: 'smooth', block: 'start' });

    }, duration);


  }
}

document.addEventListener('DOMContentLoaded', () => {
  const accordionBlocks = document.querySelectorAll(
    '.--js-accordion-block'
  );
  if (accordionBlocks.length > 0) {
    accordionBlocks.forEach((accordion) => {
      new Accordion(accordion);
    });
  }
});
